export default "__VITE_ASSET__Bysw5NtK__"